<script lang="ts">
  import Card from "../atoms/Card.svelte";
  import ErrorText from "../atoms/ErrorText.svelte";
  import ZipCodeInput from "../atoms/ZipCodeInput.svelte";
  interface Props {
    zipcode: string | undefined;
    valid?: boolean;
    children?: import("svelte").Snippet;
    hasPressedContinue?: boolean;
    disabled?: boolean;
  }

  let {
    zipcode = $bindable(),
    valid = $bindable(),
    children,
    hasPressedContinue = $bindable(false),
    disabled = $bindable(false),
  }: Props = $props();

  // "dirty" (value changed since mount) + blur gate the v1 error message, mirroring
  // the information screen's fields: pristine and tabbed-through fields stay neutral,
  // and the message is held back while the user is still typing in the field.
  let dirty = $state(false);
  let focused = $state(false);
  let previousZipcode = zipcode;

  $effect(() => {
    valid = !!zipcode && zipcode.length === 5;
  });

  $effect(() => {
    if (zipcode !== previousZipcode) {
      dirty = true;
      previousZipcode = zipcode;
    }
  });

  const showError = $derived(!valid && (hasPressedContinue || (dirty && !focused)));
</script>

<Card class="mb-3 h-auto">
  <div class="mb-3">
    {#if showError}
      <ErrorText id="zipCode-error">Vänligen fyll i ett korrekt postnummer för att fortsätta.</ErrorText>
    {:else}
      <div class="mb-3">
        <span class="block text-H5 font-bold">{@render children?.()}</span>
      </div>
    {/if}
  </div>
  <ZipCodeInput
    name={"zipcode"}
    {hasPressedContinue}
    id={"zipCode"}
    error={(!!zipcode && zipcode.length !== 5) || showError}
    ariaDescribedby={showError ? "zipCode-error" : undefined}
    onfocus={() => (focused = true)}
    onblur={() => (focused = false)}
    class="w-28"
    {disabled}
    bind:value={zipcode}
  />
</Card>
